/** What the keyboard can land on, in the order Tab reaches it. */
const REACHABLE =
  'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

/** A panel's stops for the Tab key, in the order it walks them. */
export function tabStops(panel: HTMLElement | null): HTMLElement[] {
  return panel ? [...panel.querySelectorAll<HTMLElement>(REACHABLE)] : [];
}

/**
 * Where the key should go instead when it would leave a panel that keeps the
 * keyboard: Tab off the last stop comes round to the first, and Shift+Tab off
 * the first to the last. `undefined` leaves the key to the browser.
 */
export function wrapTarget(
  stops: readonly HTMLElement[],
  at: Element | null,
  backwards: boolean,
): HTMLElement | undefined {
  if (backwards) return at === stops[0] ? stops.at(-1) : undefined;
  return at === stops.at(-1) ? stops[0] : undefined;
}
